<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <v-btn
                    class="mb-0"
                    small
                    color="success"
                    href="/messages-mobile"
                    >Messages</v-btn
                >
                <material-card color="green" title="Calls">
                    <div v-for="(call, index) in callDetails">
                        <div @click="viewDetails(call)">
                            <div>
                                <v-icon
                                    class="mr-2 "
                                    dark
                                    :color="getStatusIcon(call).color"
                                    >{{ getStatusIcon(call).icon }}</v-icon
                                >
                            </div>
                            <div class="my-1">
                                {{ formatTime(call.Timestamp) }}
                            </div>
                            <div>
                                {{ call.Name + "        " + call.CallerID }}
                            </div>
                            <div class="mt-2">
                                {{ getCallDuration(call) }}
                            </div>
                            <v-divider
                                class="mb-2 mt-1"
                                v-if="index + 1 < callDetails.length"
                                :key="index"
                            ></v-divider>
                        </div>
                        <div
                            v-if="
                                clickedCall &&
                                    call.Call_UUID == clickedCall.Call_UUID
                            "
                            class="my-2 pt-2"
                            style="border: 1px solid #5cb860"
                        >
                            <div
                                v-for="(action, index) in clickedCall.Logs"
                                class="px-2"
                            >
                                <div class="mb-2 body-2">
                                    {{ action.Description }}
                                </div>
                                <div>
                                    {{ formatTime(action.Timestamp) }}
                                </div>
                                <audio
                                    v-if="action.RecordingURL"
                                    controls
                                    class="mt-2"
                                    style="width: 100%;"
                                    :src="action.RecordingURL"
                                    ref="recording"
                                ></audio>
                                <div class="progress mt-2 mb-2">
                                    <span
                                        id="progress-amount"
                                        v-if="action.RecordingURL"
                                        ref="recordingProgress"
                                    ></span>
                                </div>
                                <v-divider
                                    class="mb-2 mt-1"
                                    v-if="index + 1 < clickedCall.Logs.length"
                                ></v-divider>
                            </div>
                        </div>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="viewCallDialog" max-width="750" scrollable>
            <v-card class="p-2">
                <v-card-title class="headline pb-2">Call Activity</v-card-title>
                <div style="height: 250px; overflow-y: auto;">
                    <v-card-text class="mb-3">
                        <v-layout column>
                            <div>
                                <div class="font-weight-medium mb-2">
                                    {{ clickedCall.Name }}
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <div>
                                <v-layout row class="mb-2">
                                    <div class="font-weight-medium mr-2">
                                        Call Time:
                                    </div>
                                    <div>
                                        {{ formatTime(clickedCall.Timestamp) }}
                                    </div>
                                </v-layout>
                            </div>
                        </v-layout>
                    </v-card-text>
                    <div
                        v-for="(action, index) in clickedCall.Logs"
                        class="px-3"
                    >
                        <div class="mb-2 body-2">{{ action.Description }}</div>
                        <div>
                            {{ formatTime(action.Timestamp) }}
                        </div>
                        <audio
                            v-if="action.RecordingURL"
                            controls
                            class="mt-2"
                            style="width: 100%;"
                            :src="action.RecordingURL"
                            ref="recording"
                        ></audio>
                        <div class="progress mt-2 mb-2">
                            <span
                                id="progress-amount"
                                v-if="action.RecordingURL"
                                ref="recordingProgress"
                            ></span>
                        </div>
                        <v-divider
                            class="mb-2 mt-1"
                            v-if="index + 1 < clickedCall.Logs.length"
                        ></v-divider>
                    </div>
                    <!-- <v-list class="px-3">
                        <div >
                            <v-list-tile class="mt-1 mb-0 px-0"
                                ><v-list-tile-title class="px-0">{{
                                    action.Description
                                }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                class="row-height"
                                v-bind:class="{
                                    'mt-0': action.RecordingURL,
                                    'mb-4': action.RecordingURL,
                                }"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{
                                        formatTime(action.Timestamp)
                                    }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-spacer></v-spacer>
                                <v-list-tile-action style="height: 90px;">
                                    <audio
                                        style="height: 33px;"
                                        v-if="action.RecordingURL"
                                        class="mt-4 px-3"
                                        controls
                                        :src="action.RecordingURL"
                                        ref="recording"
                                    ></audio>
                                    <div class="progress mt-2">
                                        <span
                                            id="progress-amount"
                                            v-if="action.RecordingURL"
                                            ref="recordingProgress"
                                        ></span>
                                    </div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider
                                v-if="index + 1 < clickedCall.Logs.length"
                            ></v-divider>
                        </div>
                    </v-list> -->
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mb-2"
                        @click="viewCallDialog = false"
                        color="#999"
                        dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 20,
                page: 1,
            },

            headers: [
                { value: "Status", text: "Status" },
                { value: "Name", text: "Caller" },
                { value: "CallerID", text: "Caller ID" },
                { value: "Timestamp", text: "Time" },
                { value: "duration", text: "Duration" },
                // { value: "HangupCauseName", text: "Hangup Cause" }
            ],

            calls: [],
            callDetails: [],

            clickedCall: "",
            viewCallDialog: false,
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    created() {
        this.loadData();
        this.firebaseSetup();
    },
    mounted() {
        //this.intervalID = window.setInterval(this.loadLastCalls, 60000);
    },
    beforeDestroy() {
        //window.clearInterval(this.intervalID);
    },
    methods: {
        async loadData() {},
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("calls");

            const callsRef = ref.orderByKey().limitToLast(300);

            callsRef.on(
                "value",
                (snapshot) => {
                    const callDetails = Object.values(snapshot.val()).map(
                        (call) => {
                            call.duration = call.Duration;
                            call.CallerID = this.formatPhoneNumber(
                                call.CallerID
                            );

                            return call;
                        }
                    );
                    this.callDetails = callDetails.sort((a, b) => {
                        if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                            return -1;
                        if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                            return 1;
                        return 0;
                    });

                    this.pagination.totalItems = callDetails.length;
                },
                function(error) {
                    console.log("Error: " + error.code);
                }
            );
        },
        getCallDuration(item) {
            if (item.duration > 0)
                return moment("2015-01-01")
                    .startOf("day")
                    .seconds(item.duration)
                    .format("mm:ss");

            const endTime = item.Logs[item.Logs.length - 1].Timestamp;

            const duration = moment.duration(
                moment(endTime).diff(moment(item.Timestamp))
            );

            return moment.utc(duration.as("milliseconds")).format("mm:ss");
        },
        getStatusIcon(item) {
            if (item.duration) {
                return {
                    icon: "mdi-check-circle",
                    color: "success",
                };
            }

            return {
                icon: "mdi-clock",
                color: "#fdb400",
            };
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8081") ||
                window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44337"
                : window.location.origin;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getPlaybackSeconds(index) {
            const logs = this.clickedCall.Logs.filter((l) => l.RecordingURL);

            const event1 = logs[index];
            const originalIndex = this.clickedCall.Logs.indexOf(event1);

            let event2 = "";

            if (this.clickedCall.Logs.length == originalIndex + 1) {
                event2 = { Timestamp: this.clickedCall.EndTime };
            } else {
                event2 = logs[index + 1];
            }

            const duration = moment.duration(
                moment(event2.Timestamp).diff(moment(event1.Timestamp))
            );

            return duration.asSeconds();
        },
        closeCallDetails() {
            this.viewCallDialog = false;
            this.clickedCall = "";
        },
        viewDetails(item) {
            if (item.Call_UUID == this.clickedCall.Call_UUID) {
                this.clickedCall = "";

                return;
            }

            item.EndTime = item.EndTime
                ? item.EndTime
                : item.Logs[item.Logs.length - 1].Timestamp;

            this.clickedCall = item;

            //this.viewCallDialog = true;

            setTimeout(this.setPlaybackTime, 0);
        },
        setPlaybackTime() {
            this.clickedCall.Logs.filter((l) => l.RecordingURL).forEach(
                (log, index) => {
                    if (!this.$refs.recording || !this.$refs.recording[index])
                        return;

                    this.$refs.recording[
                        index
                    ].currentTime = this.getPlaybackSeconds(index);

                    this.addProgressEvent(this.$refs.recording[index], index);
                }
            );
        },
        addProgressEvent(myAudio, index) {
            myAudio.addEventListener("timeupdate", (e) =>
                this.updateProgress(e, index)
            );
        },
        updateProgress(e, index) {
            const duration = this.$refs.recording[index].duration;

            if (duration > 0) {
                this.$refs.recordingProgress[index].style.width =
                    (this.$refs.recording[index].currentTime / duration) * 100 +
                    "%";
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}

.row-height.v-list__tile theme--light {
    min-height: 100px !important;
    height: 100px !important;
}
.progress {
    margin-top: -20px;
    height: 5px;
    position: relative;
    width: 300px;
}

#progress-amount {
    display: block;
    height: 100%;
    background-color: #5cb860;
    width: 0;
}
</style>
